import React from "react";

const StoresContext = React.createContext({
  stores: {},
  onLightingStoresChange: () => {}
});

export default StoresContext;
